import { gql } from "@apollo/client";

export const GET_CSV_FIELDS = gql`
query Query($campaignId: String!) {
  getCSVFieldList(campaignId: $campaignId){
    campaignTypeAvailable
		csvFields
  }
}
`

export const GET_GLOBAL_OUTBOUNDS_FIELDS = gql`
query GetGlobalOutboundFieldList {
  getGlobalOutboundFieldList {
    _id
    fieldName
    fieldValue
  }
}
`

export const GET_ALL_LEADS=gql`
query Query($campaignId: String!) {
  getCampaignLeads(campaignId: $campaignId) {
    firstName
    lastName
    email
    phone
  }
}
`